export const BOT_ID = ['botId'];
export const DISTRIBUTION = ['distribution'];
export const FALLBACK = ['fallback'];
export const ROTATION_METHOD = ['rotationMethod'];
export const TEAM_IDS = ['teamIds'];
export const TYPE = ['@type'];
export const USER_IDS = ['userIds'];